import { ColumnList, ColumnListContent, ColumnListTrigger } from "@qw/ui";
import { useInboxQueryStates } from "@/providers/inbox-query-states-provider";
import { InsuredLink } from "./insured-link";
import { useScopedItems } from "./use-book-scope";
import { useFilteredInsureds } from "./use-filtered-insureds";
import type { ItemWithInsured } from "./use-pinned-insureds";

export const BookResultsList = <T,>({
  items,
  label,
  variant,
}: {
  items: ItemWithInsured<T>[];
  label: string;
  variant?: "default" | "renewal";
}) => {
  const { searchTerm } = useInboxQueryStates();
  // Scope first, term second: the chip is a fence and the term is a search inside it, so fuzzy
  // matching the whole list and then filtering would let a strong match outside the scope push a
  // weaker one inside it off the list.
  const scopedItems = useScopedItems(items);
  const results = useFilteredInsureds(scopedItems, searchTerm);

  if (results.length === 0) {
    return null;
  }

  return (
    <ColumnList label={label} open={true}>
      <ColumnListTrigger label={label} count={results.length} disabled />
      {results.length > 0 && (
        <ColumnListContent>
          {results.map((item) => (
            <InsuredLink key={item.insured.id} item={item} variant={variant} />
          ))}
        </ColumnListContent>
      )}
    </ColumnList>
  );
};
